

































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import { InternalSite, Employee, siteAdminApis, adminType } from '../../api';
import EmployeeTransfer from '../../components/EmployeeTransfer.vue';
import SiteEditDialog from './SiteEditDialog.vue';
import SitePermsTable from './SitePermsTable.vue';
import SiteRolesTable from './SiteRolesTable.vue';
import PermGrant from './PermGrant.vue';

@Component({
  components: { EmployeeTransfer, SiteEditDialog, SitePermsTable, SiteRolesTable, PermGrant }
})
export default class SiteDetail extends Vue {
  readonly labelWidth = '6rem';

  @Ref('site-edit-dialog') siteEditDialog!: SiteEditDialog;
  @Prop({ required: true }) siteId!: number;

  siteAdminsDialogVisible = false;
  employees: Array<Employee> = [];
  admins: Array<Employee> = [];
  activeTab = 'perm_role';
  admin_type = '1';
  admin_title = '';

  mounted() {
    this.$watch('siteId', function() {
      this.activeTab = 'perm_role';
    });
  }

  get site(): InternalSite {
    return this.$store.getters['sites/getSite'](this.siteId);
  }

  get canEditSite() {
    return this.$store.getters['perms/has']('superadmin') || this.$store.getters['perms/has']('develop-admin');
  }

  showEdit(editAddressOnly: boolean) {
    this.siteEditDialog.show(this.site, editAddressOnly);
  }

  getPerm(type: string) {
    const perm = adminType[type];
    return this.site.perms.indexOf(perm) > -1;
  }

  showAdmins(type: string) {
    const admin_type = adminType[type];
    siteAdminApis.getAdmins(this.site.id, admin_type).then(admins => {
      this.admins = admins;
    });
    if (admin_type == adminType['Configurator']) {
      this.admin_title = '配置管理员';
    } else {
      if (admin_type == adminType['Auditor']) {
        this.admin_title = '审计管理员';
      } else {
        this.admin_title = '授权管理员';
      }
    }
    this.siteAdminsDialogVisible = true;
    this.admin_type = admin_type;
  }

  async grantAdmin(employee: Employee) {
    await siteAdminApis.grantAdmin(this.site.id, employee.id, this.admin_type);
    this.admins.push(employee);
    this.$notify.success('添加管理员成功');
  }

  async revokeAdmin(employee: Employee) {
    await siteAdminApis.revokeAdmin(this.site.id, employee.id, this.admin_type);
    const idx = this.admins.findIndex(x => x.id === employee.id);
    if (idx > -1) {
      this.admins.splice(idx, 1);
    }
    this.$notify.success('删除管理员成功');
  }

  async deleteSite() {
    const site = this.site;
    await this.$store.dispatch('sites/delete', site);
    this.$notify.success(`删除站点[ ${site.title} ]成功`);
    this.$router.push('/sites');
  }
}
